export const IDENTITY = {
    name: "Dwiki Arlian Maulana",
    handle: "wikidotexe",
    masthead: "VOL. 26 / ISSUE 02 / JAKARTA, ID",
    role: "IT Support & System Engineer",
    tagline:
        "6+ years untangling stubborn Linux servers, high-density networks, and cloud architecture.",
    punchline:
        "Fluent in blinking router lights, bash scripts at sunrise, and that satisfying green-dashboard uptime.",
    location: "Jakarta, Indonesia",
    status: "Available for Select Contracts & High-Stakes Infra Consultations",
    email: "dwiki.arlianm@gmail.com",
    resume: "https://space.wikiarlianm.com/s/qEHqDBAJxq9eFky",
    github: "https://github.com/wikidotexe",
    linkedin: "https://linkedin.com/in/dwiki-arlian-maulana-852b14209",
};

export const IMAGES = {
    portrait: "https://wikidotexe-personal.vercel.app/portrait.jpg",
    portraitFallback:
        "https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const STATS = [
    { label: "Experience", value: "6+", unit: "Years", detail: "System Admin & Infrastructure" },
    { label: "Deployments", value: "34+", unit: "Systems", detail: "Nodes, Services & Production Stacks" },
    { label: "Reliability SLA", value: "99.98%", unit: "Uptime", detail: "Mission-Critical Obsession" },
    { label: "Traffic Handled", value: "100k+", unit: "Packets/Day", detail: "High-Density Routing" },
];

export const NAV_LINKS = [
    { label: "Frontpage", href: "/" },
    { label: "About", href: "/about" },
    { label: "Chronology", href: "/experience" },
    { label: "Work", href: "/work" },
    { label: "Accreditation", href: "/certificates" },
    { label: "Contact", href: "/contact" },
];

export const MARQUEE_TOKENS = [
    "NETWORKING",
    "SYSTEM ADMIN",
    "CLOUD INFRA",
    "OBSERVABILITY",
    "ZERO-TRUST",
    "DOCKER",
    "PROMETHEUS",
    "AUTOMATION",
    "TROUBLESHOOTING",
    "SECURITY",
];

export const EXPERIENCE = [
    {
        period: "2026 — Now",
        role: "IT Automation Lead",
        company: "Aeris Beaute",
        description:
            "Leading tech stack implementation, internal system development (Next.js/React, Laravel, MySQL/PostgreSQL), and server/cloud infrastructure management (Docker, VPS, monitoring). Driving cybersecurity & data governance initiatives, and spearheading AI adoption strategy across departments as internal technology consultant.",
        tags: ["Next.js", "React", "Laravel", "Node.js", "MySQL", "PostgreSQL", "Docker", "CasaOS", "Nextcloud", "Grafana", "Prometheus", "OpenVPN", "N8N", "Ollama", "Linux", "Wireshark"],
    },
    {
        period: "2025 — 2026",
        role: "IT Support & System",
        company: "Saff & Co.",
        description:
            "Managed network infrastructure, server configurations, and end-user systems across multiple locations. Deployed VPN and firewall solutions, maintained private cloud environments, and provided on-site and remote technical support for business operations.",
        tags: ["Synology", "Linux", "Rustdesk", "Network", "OpenVPN", "Docker", "Shopify", "Cloudflare", "Nginx", "Unifi", "Laravel", "MySQL", "CI/CD", "Next.js", "SSL/TLS"],
    },
    {
        period: "2021 — 2025",
        role: "IT Support",
        company: "BLP Beauty",
        description:
            "Managed network infrastructure, server configurations, and end-user systems across multiple locations. Deployed VPN and firewall solutions, maintained private cloud environments, and provided on-site and remote technical support.",
        tags: ["MikroTik", "Synology NAS", "Linux", "Rustdesk", "Network", "OpenVPN", "WSL", "Docker", "Shopify", "Cloudflare", "Grafana"],
    },
    {
        period: "2020 — 2021",
        role: "IT Technician",
        company: "PT. Smartindo Integrasi System",
        description:
            "Performed hardware and software troubleshooting, handled pre-shipment quality checks, configured operating systems, and ensured data integrity through backups and recovery operations.",
        tags: ["Windows", "Linux", "Hardware", "Software", "Network"],
    },
    {
        period: "2018 — 2019",
        role: "IT Support Technician",
        company: "Digital Alliance ID",
        description:
            "Troubleshot and repaired computer hardware, diagnosed network issues, and ensured all refurbished devices met performance and quality standards.",
        tags: ["Windows", "MikroTik", "Remote Desktop", "Software", "Hardware"],
    },
];

export const CERTIFICATES = [
    { id: "CERT-01", title: "Technical Support Basics", issuer: "Google", category: "Foundations", image: "https://wikidotexe-personal.vercel.app/certificate/google.webp", link: "https://coursera.org/verify/K6K3V3QEE5NT" },
    { id: "CERT-02", title: "Introduction to Technical Support", issuer: "IBM", category: "Enterprise Support", image: "https://wikidotexe-personal.vercel.app/certificate/ibm.webp", link: "https://wikidotexe-personal.vercel.app/certificate/ibm.webp" },
    { id: "CERT-03", title: "Learn Computer Networks for Beginners", issuer: "Dicoding", category: "Networking", image: "https://wikidotexe-personal.vercel.app/certificate/dicoding.webp", link: "https://wikidotexe-personal.vercel.app/certificate/dicoding.webp" },
    { id: "CERT-04", title: "Learn DevOps Fundamentals", issuer: "Dicoding", category: "DevOps", image: "https://wikidotexe-personal.vercel.app/certificate/dicoding2.webp", link: "https://wikidotexe-personal.vercel.app/certificate/dicoding2.webp" },
    { id: "CERT-05", title: "Desktop IT Support Level 1 & 2 in Real Life", issuer: "Udemy", category: "L1/L2 Operations", image: "https://wikidotexe-personal.vercel.app/certificate/udemy.webp", link: "https://wikidotexe-personal.vercel.app/certificate/udemy.webp" },
    { id: "CERT-06", title: "Mastering Docker from Basics to Practice", issuer: "BuildWithAngga", category: "Containerization", image: "https://wikidotexe-personal.vercel.app/certificate/docker.webp", link: "https://wikidotexe-personal.vercel.app/certificate/docker.webp" },
    { id: "CERT-07", title: "Decoding DevOps — From Basics to Advanced Projects with AI", issuer: "Udemy", category: "Modern CI/CD & AI", image: "https://wikidotexe-personal.vercel.app/certificate/udemy2.webp", link: "https://wikidotexe-personal.vercel.app/certificate/udemy2.webp" },
];

export const PROJECT_FILTERS = [
    { key: "all", label: "All" },
    { key: "infrastructure", label: "Infrastructure" },
    { key: "web", label: "Web Dev" },
    { key: "network", label: "Network & Access" },
    { key: "observability", label: "Observability" },
    { key: "cloud", label: "Cloud" },
];

export const PROJECTS = [
    {
        id: "PRJ-01", number: "01", title: "Synology Server Setup", category: "Infrastructure", filter: "infrastructure",
        client: "PT Tombrok Jaya Permai",
        description: "Well-integrated storage and network system providing optimal data security, remote DDNS accessibility, and a structured backup strategy that guarantees business continuity.",
        image: "https://wikidotexe-personal.vercel.app/projects/Tombrok%20Project.webp",
        fallback: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85",
        tags: ["Synology", "Winbox", "DDNS", "Nginx Reverse Proxy", "MikroTik", "Proxmox", "Cloudflare", "OpenVPN", "Dell Workstation", "Virtualization"],
    },
    {
        id: "PRJ-02", number: "02", title: "Internal Web App System — 6 Modules", category: "Web App & Ops", filter: "web",
        client: "SAFF & Co.",
        description: "Internal operations platform featuring Meeting Room Booking, Legal Request, Car Booking, Asset Request, Creative Asset, and Digital Library modules — with automated Cloudflare cache purging and Turnstile bot protection.",
        image: "https://wikidotexe-personal.vercel.app/projects/saffnco%20project.webp",
        fallback: "https://images.pexels.com/photos/6963944/pexels-photo-6963944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tags: ["React JS", "Laravel", "Cloudflare", "Nginx", "CI/CD", "GitHub Action", "MySQL", "PHP", "Tailwind", "Turnstile", "Docker", "Reverse Proxy", "Linux", "DDNS"],
    },
    {
        id: "PRJ-03", number: "03", title: "RustDesk Self-Hosted Remote Access", category: "Remote Access", filter: "network",
        client: "PT Lizzie Parra Kreasi (BLP Beauty)",
        description: "Self-hosted RustDesk relay and rendezvous servers on Synology NAS Docker — secure, zero-lag remote access replacing expensive commercial tooling.",
        image: "https://wikidotexe-personal.vercel.app/projects/rustdesk.webp",
        fallback: "https://images.pexels.com/photos/5380589/pexels-photo-5380589.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tags: ["Docker", "Port-forwarding", "REST API", "Winbox", "Nginx Reverse Proxy", "Remote Desktop", "DDNS"],
    },
    {
        id: "PRJ-04", number: "04", title: "CasaOS Dashboard for VPS CLI", category: "Server Management", filter: "infrastructure",
        client: "BLP Beauty",
        description: "CasaOS web-based dashboard to manage VPS nodes via an intuitive UI — Docker orchestration, Nginx reverse proxy, and secure DDNS remote access.",
        image: "https://wikidotexe-personal.vercel.app/projects/casaos.webp",
        fallback: "https://images.unsplash.com/photo-1629654297299-c8506221ca97?crop=entropy&cs=srgb&fm=jpg&q=85",
        tags: ["Docker", "CasaOS", "Linux", "Nginx Reverse Proxy", "Remote Desktop", "DDNS", "Port-forwarding"],
    },
    {
        id: "PRJ-05", number: "05", title: "Grafana Network & Server Monitoring", category: "Observability", filter: "observability",
        client: "BLP Beauty Infra",
        description: "Telemetry pipeline with Prometheus, Node Exporter, and SNMP streaming MikroTik router and server stats into real-time, high-fidelity Grafana dashboards.",
        image: "https://wikidotexe-personal.vercel.app/projects/grafana.webp",
        fallback: "https://images.pexels.com/photos/9951077/pexels-photo-9951077.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tags: ["Grafana", "Prometheus", "SNMP", "MikroTik", "Node Exporter", "Docker", "Synology", "Linux", "Nginx Reverse Proxy"],
    },
    {
        id: "PRJ-06", number: "06", title: "MikroTik Hotspot & Captive Portal", category: "Networking", filter: "network",
        client: "BLP Beauty HQ",
        description: "Enterprise hotspot system for 100+ concurrent employees — friendly login portal, DHCP isolation, SSL/TLS certificates, and bandwidth management.",
        image: "https://wikidotexe-personal.vercel.app/projects/hostpot.webp",
        fallback: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&q=85",
        tags: ["MikroTik", "Winbox", "REST API", "Webserver", "Nginx Reverse Proxy", "SSL/TLS", "DHCP Server", "Port-forwarding"],
    },
    {
        id: "PRJ-07", number: "07", title: "Server Rack — MikroTik RB1100 Deployment", category: "Infrastructure", filter: "infrastructure",
        client: "PT Smartec Teknologi Indonesia",
        description: "MikroTik RB1100 HX2 deployment at 1Gbps supporting 100+ users with seamless file sharing and clean rack cable management.",
        image: "https://wikidotexe-personal.vercel.app/projects/installation.webp",
        fallback: "https://images.pexels.com/photos/2881232/pexels-photo-2881232.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tags: ["MikroTik", "Winbox", "TP-Link", "Cisco Packet Tracer", "Wireshark"],
    },
    {
        id: "PRJ-08", number: "08", title: "Enterprise Branch Server Setup", category: "Infrastructure", filter: "infrastructure",
        client: "PT BON CAFE INDONESIA",
        description: "MikroTik RB1100 HX2 routing at 1Gbps for 50+ users — Ruijie switching, Windows Server, WHM and internal mail exchange for smooth collaboration.",
        image: "https://wikidotexe-personal.vercel.app/projects/setupnewdevice.webp",
        fallback: "https://images.pexels.com/photos/325229/pexels-photo-325229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tags: ["MikroTik", "Winbox", "Ruijie", "TP-Link", "Cisco Packet Tracer", "Windows Server", "WHM", "Mail Server"],
    },
    {
        id: "PRJ-09", number: "09", title: "Engineering Corporate Landing Page", category: "Web Dev", filter: "web",
        client: "CV Berkah Teknik Mandiri",
        description: "Responsive landing page for an engineering and construction services company — fast, clean, and conversion-focused.",
        image: "https://wikidotexe-personal.vercel.app/projects/landingpage.webp",
        fallback: "https://images.unsplash.com/photo-1563206767-5b18f218e8de?crop=entropy&cs=srgb&fm=jpg&q=85",
        tags: ["PHP", "CSS", "JavaScript", "Bootstrap", "MySQL"],
    },
    {
        id: "PRJ-10", number: "10", title: "Nextcloud Self-Hosted Private Cloud", category: "Cloud Computing", filter: "cloud",
        client: "Self-Hosted Homelab",
        description: "Hardened Ubuntu home server running Nextcloud with Redis caching, Cloudflare tunneling, and DDNS — private cloud, zero subscription fees.",
        image: "https://wikidotexe-personal.vercel.app/projects/nextcloud.webp",
        fallback: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?crop=entropy&cs=srgb&fm=jpg&q=85",
        tags: ["Nextcloud", "Docker", "MySQL", "Nginx", "Linux", "Cloudflare", "Redis", "DDNS"],
    },
    {
        id: "PRJ-11", number: "11", title: "Company Profile WebApp + Admin Panel", category: "Web Dev", filter: "web",
        client: "NoFileExistsHere",
        description: "WebApp-based company profile with a Filament/Livewire admin panel — content fully editable, assets delivered instantly.",
        image: "https://wikidotexe-personal.vercel.app/projects/webapp.webp",
        fallback: "https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tags: ["PHP", "Laravel", "Filament", "Livewire", "MySQL", "Redis", "Tailwind", "Bootstrap"],
    },
    {
        id: "PRJ-12", number: "12", title: "wikiOS — Desktop Portfolio", category: "Frontend & Motion", filter: "web",
        client: "wikidotexe Lab",
        description: "This very site — a full Linux desktop in the browser: kernel boot sequence, draggable windows, system panel with live clock, Conky-style monitor, and a working shell.",
        image: "https://wikidotexe-personal.vercel.app/projects/portfolio.webp",
        fallback: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=jpg&q=85",
        tags: ["React 19", "Tailwind CSS", "Framer Motion", "Lenis", "Editorial Brutalism", "Poppins"],
    },
];

export const SKILLS = [
    { number: "01", title: "Networking", items: ["MikroTik", "Port Forwarding", "Unifi", "VLAN", "VPN", "Firewall", "Load Balancing"] },
    { number: "02", title: "System Admin", items: ["Linux", "Windows Server", "Active Directory", "Google Workspace", "Microsoft 365", "Synology NAS"] },
    { number: "03", title: "Infrastructure", items: ["Virtualization", "Proxmox", "Docker", "Nginx/Apache", "CI/CD", "Cloudflare"] },
    { number: "04", title: "Scripting", items: ["Bash", "PowerShell", "Terminal", "VIM/Nano", "Cron"] },
    { number: "05", title: "Development", items: ["Laravel", "Next.js", "Tailwind", "Python", "PHP", "JavaScript"] },
    { number: "06", title: "Automation", items: ["N8N", "OpenClaw", "9Router", "Ollama"] },
];

export const SERVICES = [
    "Infrastructure Setup",
    "Network & VPN",
    "Web Development",
    "Monitoring & Observability",
    "Automation",
    "Consulting",
];


// Live content hydration: admin-edited content from the API replaces the bundled defaults in place,
// so every window component keeps working with the same imports.
const assignObj = (target, src) => {
    if (src && typeof src === "object" && !Array.isArray(src)) {
        Object.keys(target).forEach((k) => delete target[k]);
        Object.assign(target, src);
    }
};
const assignArr = (target, src) => {
    if (Array.isArray(src)) {
        target.length = 0;
        target.push(...src);
    }
};

export const applyContent = (data) => {
    if (!data) return;
    assignObj(IDENTITY, data.identity);
    assignObj(IMAGES, data.images);
    assignArr(STATS, data.stats);
    assignArr(EXPERIENCE, data.experience);
    assignArr(CERTIFICATES, data.certificates);
    assignArr(PROJECTS, data.projects);
    assignArr(SKILLS, data.skills);
    assignArr(SERVICES, data.services);
};

export const hydrateContent = async () => {
    try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`);
        if (!res.ok) return;
        applyContent(await res.json());
    } catch {
        /* bundled defaults stay */
    }
};
